module.exports = __webpack_public_path__ + "img/1440.e9f2fa39.jpg";